<template>
  <div class="wrapper-mirror">
    <div class="section-title">
      {{ title }}
    </div>
    <div class="mirror-folder-input">
      <v-select
        class="mirror-folder-input-place"
        :items="adminPlaces"
        item-text="place_name"
        label="Praça"
        outlined
        dense
        color="primary"
        v-model="placeMirror"
      />
      <v-text-field
        label="Gaveta (ex: PAUTA.RJ.REDE.SEG)"
        v-model="mirrorFolder"
        dense
        outlined
        clearable
      />
    </div>
    <div class="mirror-folder-input">
      <v-text-field
        label="Nome (ex: Bom dia Rio)"
        v-model="nameMirror"
        dense
        outlined
        clearable
      />
      <v-text-field
        label="Nome Curto (ex: BDRJ)"
        v-model="shortName"
        dense
        outlined
        clearable
      />
    </div>
    <div class="mirror-folder-input">
      <v-text-field
        label="Horário (ex: 06:01:00)"
        v-model="startTime"
        dense
        outlined
        clearable
      />
      <v-text-field
        label="URL da logo"
        v-model="imageUrl"
        dense
        outlined
        clearable
      />
      <v-text-field v-model="folderId" type="hidden" class="hidden" />
    </div>
    <div class="mirror-folder-input">
      <v-autocomplete
        class="mirror-folder-input-category"
        label="Categoria"
        :value="category"
        dense
        outlined
        block
        clearable
        @input="handleCategory"
        @update:search-input="searchCategory = $event"
        :items="categories"
      >
      </v-autocomplete>
    </div>
    <div class="mirror-folder-input actions">
      <v-btn height="40" class="clear-button" @click="resetMirrorValues">
        Limpar
      </v-btn>
      <v-btn
        color="primary"
        height="40"
        class="save-mirror-button"
        @click="handleSaveMirrorFolder"
      >
        Salvar
      </v-btn>
    </div>
    <div class="section-title">
      Espelhos cadastrados serão exibidos para os jornalistas
    </div>
    <v-expansion-panels accordion>
      <v-expansion-panel
        v-for="(mirrors, category) in this.adminMirrorFolders"
        :key="category"
      >
        <v-expansion-panel-header>{{ category }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="mirrorTableHeader"
            :items="mirrors"
            disable-pagination
            fixed-header
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="handleEditMirror(item, category)"
              >
                mdi-pencil
              </v-icon>
              <v-icon small @click="removeMirror(item, item.place)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- modal deletion -->
    <v-dialog v-model="deleteMirrorDialog" max-width="480">
      <v-card>
        <v-row>
          <v-icon color="gray">error_outline</v-icon>
        </v-row>
        <v-card-title class="headline">Remover</v-card-title>
        <v-card-text>
          Tem certeza que deseja remover o espelho
          <strong>{{ this.toDelete.name }}</strong>
          ?
        </v-card-text>
        <v-card-actions>
          <v-btn large outlined text @click="deleteMirrorDialog = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            large
            outlined
            text
            @click="confirmMirrorDeletion()"
          >
            Sim, desejo remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal deletion:end -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'MirrorsForm',
  props: {
    adminMirrorFolders: Object,
    adminPlaces: Array,
  },
  data() {
    return {
      snackbarTimeout: 6000,
      drawer: false,
      searchCategory: '',
      placeMirror: null,
      nameMirror: null,
      shortName: null,
      imageUrl: null,
      startTime: null,
      category: null,
      mirrorFolder: null,
      mirror_category: null,
      folderId: null,
      folderList: [],
      isEdit: false,
      deleteMirrorDialog: false,
      toDelete: {
        folder_id: null,
        name: null,
      },
      mirrorTableHeader: [
        {
          text: 'Nome',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Gaveta', value: 'path' },
        { text: 'Hora', value: 'start_time' },
        { text: 'Ações', value: 'actions' },
      ],
    };
  },
  methods: {
    handleCategory(value) {
      this.category = this.formatCategory(value);

      this.mirror_category = this.selectedMirrorCategory(value);
    },
    formatCategory(value) {
      if (!value) return '';
      const valueUp = value.toUpperCase();
      return valueUp.trim();
    },
    handleSaveMirrorFolder() {
      if (this.validateMirrorForm()) {
        const store_dispatch = this.isEdit
          ? 'admin/updateMirrorFolder'
          : 'admin/createMirrorFolder';
        this.$store.dispatch(store_dispatch, {
          place: this.placeMirror,
          name: this.nameMirror,
          short_name: this.shortName,
          image_url: this.imageUrl,
          start_time: this.startTime,
          category: this.category,
          path: this.mirrorFolder.toUpperCase(),
          folder_id: this.folderId,
          mirror_category_id: this.mirror_category.id,
        });
      } else {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Por favor preencha todos os campos',
          type: 'error',
        });
      }
    },
    validateMirrorForm() {
      return (
        this.placeMirror &&
        this.nameMirror &&
        this.startTime &&
        this.mirrorFolder &&
        this.category &&
        this.shortName
      );
    },
    handleEditMirror(mirror, category) {
      this.placeMirror = mirror.place;
      this.nameMirror = mirror.name;
      this.shortName = mirror.short_name;
      this.imageUrl = mirror.image_url;
      this.startTime = mirror.start_time;
      this.mirrorFolder = mirror.path;
      this.category = category;
      this.folderId = mirror.folder_id;
      this.mirror_category = mirror.mirror_category;
      this.isEdit = true;
    },
    resetMirrorValues() {
      this.placeMirror = '';
      this.nameMirror = '';
      this.shortName = '';
      this.imageUrl = '';
      this.startTime = '';
      this.mirrorFolder = '';
      this.category = '';
      this.folderId = null;
      this.mirror_category = null;
      this.isEdit = false;
    },
    removeMirror(mirror) {
      this.deleteMirrorDialog = true;
      this.toDelete = mirror;
    },
    confirmMirrorDeletion() {
      this.$store.dispatch('admin/removeMirror', this.toDelete);
      this.deleteMirrorDialog = false;
    },
    selectedMirrorCategory(categoryName) {
      const mirrorCategorySelected = this.adminMirrorCategories.find(
        category => category.name === categoryName,
      );

      return mirrorCategorySelected;
    },
  },

  computed: {
    ...mapState({
      adminMirrorCategories: state => state.admin.adminMirrorCategories,
    }),
    title() {
      return this.isEdit ? 'Atualizar espelho' : 'Criar novo espelho';
    },
    categories() {
      const categories = this.adminMirrorCategories.map(
        category => category.name,
      );

      return categories;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.wrapper-mirror {
  width: 100vw;
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;

  .section-title {
    margin-bottom: 16px;
    margin-left: 4px;
    color: $color-gray-dark;
    font-size: 1.1em;
  }

  .mirror-folder-input {
    display: flex;
    height: 36px;
    margin-bottom: 16px;

    .mirror-folder-input-place {
      height: 36px;
      flex: 0 0 88px !important;
      margin: 0 4px 0 0;
    }

    .v-text-field {
      margin: 0 4px 0 4px;
    }

    .create-button {
      flex: 0 0 64px !important;
    }

    .save-mirror-button {
      margin-left: auto;
      margin-right: 4px;
    }

    .clear-button {
      margin-right: 4px;
    }

    .hidden {
      display: none;
    }

    .actions {
      margin-bottom: 16px;
    }
  }
}

.v-dialog {
  .v-card {
    padding: 24px;
    overflow: hidden;

    @include for-size(phone-only) {
      padding: 16px 8px;
    }

    // Icon
    .row {
      justify-content: center;

      i {
        font-size: 4em;
        opacity: 0.24;
      }
    }

    // Title
    .v-card__title {
      position: relative;
      text-align: center;
      justify-content: center;
      font-style: italic;
      color: $color-gray-dark;
      margin: -8px 0 24px 0;

      @include for-size(phone-only) {
        margin: -8px 0 8px 0;
      }
    }

    // Text
    .v-card__text {
      font-size: 1em;
      color: $color-gray-main;
      text-align: center;

      @include for-size(phone-only) {
        font-size: 0.88em;
        line-height: 1.2em;
      }

      span {
        font-family: 'globotipo' !important;
        font-weight: 700 !important;
        color: $color-gray-dark;
      }
    }

    ::v-deep .v-card__actions {
      justify-content: flex-end;

      @include for-size(phone-only) {
        display: flex;
        flex-wrap: wrap;

        .v-btn {
          flex: 0 0 100%;
          margin: 0 0 8px 0;
        }
      }
    }
  }
}
</style>
